// extracted by mini-css-extract-plugin
export default {"HeaderOneDiscovery--searchOpen":"HeaderOneDiscovery--searchOpen___N_VID"};